var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{directives:[{name:"clean-html",rawName:"v-clean-html",value:(_vm.sanitized),expression:"sanitized"}],staticClass:"markdown"}):_c('Loading')
}
var staticRenderFns = []

export { render, staticRenderFns }